import React, { useState } from 'react'
import { Select } from 'antd'
import { findProvider } from '../../services/implementation-items'

const ProviderSelector = ({ value = {}, onChange }) => {
  const [options, setOptions] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [searchQuery, setSearchQuery] = useState('')

  const onSearch = (query) => {
    setSearchQuery(query)
    if (query && query.length >= 3) {
      setIsLoading(true)
      findProvider(query)
        .then((response) => {
          if (response?.data && response?.data?.suggestions) {
            const newOptions = response.data.suggestions.map(({ name, inn }) => ({
              label: (
                <span>
                  <p>{`${name} (${inn})`}</p>
                </span>
              ),
              value: `${name} (${inn})`,
            }))
            if (newOptions.length === 0 && query) {
              setOptions([
                {
                  label: (
                    <span>
                      <strong>{query}</strong>
                    </span>
                  ),
                  value: query,
                },
              ])
            } else {
              setOptions(newOptions)
            }
          }
        })
        .catch(() => {
          setOptions([])
        })
        .finally(() => {
          setIsLoading(false)
        })
    } else {
      setOptions([])
    }
  }

  const onChangeHandler = (selectedValue) => {
    onChange(selectedValue)
  }

  const getNotFoundContent = () => {
    if (searchQuery && searchQuery.length < 3) {
      return 'Введите минимум 3 символа для поиска'
    }
    return 'Введите несколько цифр ИНН или часть названия компании для получения списка компаний'
  }

  return (
    <Select
      value={value}
      loading={isLoading}
      onSearch={onSearch}
      defaultActiveFirstOption={false}
      filterOption={false}
      showSearch
      allowClear
      style={{ width: 300 }}
      placeholder="ИНН или название организации"
      notFoundContent={getNotFoundContent()}
      onSelect={onChangeHandler}
      options={options}
      dropdownMatchSelectWidth={false}
    />
  )
}

export default ProviderSelector
